export class WalletAlreadyLinkedError extends Error {
  constructor() {
    super('This wallet is already linked to a Pixion ID. To link it and complete your transaction, you have to first unlink the wallet from its current Pixion ID.');

    this.name = 'WalletAlreadyLinkedError';
  }
}
